import * as moment from 'moment';
import { EntityType } from '../../../shared/enums/entity-type.enum';
import { Product } from '../../category/products/models/product.model';
import { CustomerInfo } from '../../customers/models/customer-info.model';
import { CouponFinality } from '../enums/coupon-finality.enum';
import { CouponStatus } from '../enums/coupon-status.enum';
import { CouponType } from '../enums/coupon-type.enum';
import { DiscountType } from '../enums/discount-type.enum';

export class CouponResponse {
  data: Coupon[];
  totalPages: number;
  totalRecords: number;
}

export class Coupon {
  id: number;
  code: string;
  creationDate: number;
  startDate: string;
  expireDate: string;
  discountMoney: number;
  discountPercent: number;
  minimumValueForUse: number;
  isMoneyDiscount: boolean;
  status: CouponStatus;
  finality: CouponFinality;
  singlePurchase: boolean;
  type: CouponType;
  quantity: number;
  totalUsed: number;
  entities: CouponEntities[];

  hour: boolean; // ??

  //auxview
  discountType: DiscountType;
  selectProducts: boolean;
  selectCustomers: boolean;
  customers: CustomerInfo[];
  products: Product[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    this.discountType = this.isMoneyDiscount ? DiscountType.FIXED : DiscountType.PERCENTAGE;

    if (this.discountType == DiscountType.PERCENTAGE) {
      this.discountMoney = null;
    } else {
      this.discountPercent = null;
    }

    if (!this.entities || this.entities.length == 0) {
      this.entities = [];
      this.selectCustomers = false;
      this.selectProducts = false;
      this.customers = [];
      this.products = [];
    } else {
      this.selectProducts = this.entities.some((item) => item.entityName == EntityType.PRODUCT);
      this.selectCustomers = this.entities.some((item) => item.entityName == EntityType.USER);
    }
  }

  toJson(): any {
    let data: any = {
      id: this.id || null,
      code: this.code,
      startDate: this.startDate ? moment(this.startDate).format('YYYY-MM-DD') + 'T00:00:00' : null,
      expireDate: this.expireDate
        ? moment(this.expireDate).format('YYYY-MM-DD') + 'T23:59:59'
        : null,
      discountMoney: this.discountMoney ? Number(this.discountMoney) : null,
      discountPercent: this.discountPercent ? Number(this.discountPercent) : null,
      minimumValueForUse: this.minimumValueForUse,
      isMoneyDiscount: this.isMoneyDiscount,
      status: this.status || CouponStatus.VALID,
      finality: CouponFinality.ORDER,
      type: this.type || CouponType.COUPON_BY_STORE,
    };
    const entities: CouponEntities[] = [];
    if (this.selectCustomers && this.customers && this.customers.length > 0) {
      this.customers.forEach((c) => {
        entities.push({
          entityName: EntityType.USER,
          entityId: c.id,
        });
      });
      data.singlePurchase = true;
      data.quantity = this.customers.length;
    } else {
      data.singlePurchase = this.singlePurchase;
      data.quantity = this.quantity;
    }

    if (this.selectProducts && this.products && this.products.length > 0) {
      this.products.forEach((p) => {
        entities.push({
          entityName: EntityType.PRODUCT,
          entityId: p.id,
        });
      });
    }
    data.entities = entities;
    return data;
  }
}

export class CouponDetails {
  users: CustomerInfo[];
  products: Product[];
}

export class CouponEntities {
  id?: number;
  entityName: EntityType;
  entityId: number;
}



// WEBPACK FOOTER //
// ./src/app/pages/coupons/models/coupon.model.ts